import React from 'react';
import { Box } from '@mui/material';
import SimpleDialog from 'components/SimpleDialog';

const FilterPodModal = ({
  open,
  children,
  actions
}) => {

  return (
    <SimpleDialog
      title="فیلتر پیشرفته"
      open={open}
      fullWidth maxWidth="sm"
      actions={actions}
    >
      <Box>
        {children}
      </Box>
    </SimpleDialog>
  );
};

export default FilterPodModal;
